const countries: {
  [key: string]: {
    CountryID: string;
    Country: string;
    Abbreviation: string;
    Airtime: string;
    MoneyTransfer: string;
    BillPayment: string;
    Voucher: string;
    DefaultCurrency: string | null;
    DeliveryMethods: {
      [key: string]: string;
    };
  };
} = {
  '0': {
    CountryID: '1',
    Country: 'Canada',
    Abbreviation: 'CA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'CAD',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '1': {
    CountryID: '2',
    Country: 'United States',
    Abbreviation: 'US',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'USD',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '2': {
    CountryID: '3',
    Country: 'Albania',
    Abbreviation: 'AL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '3': {
    CountryID: '4',
    Country: 'Algeria',
    Abbreviation: 'DZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '4': {
    CountryID: '5',
    Country: 'American Samoa',
    Abbreviation: 'AS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '5': {
    CountryID: '6',
    Country: 'Andorra',
    Abbreviation: 'AD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '6': {
    CountryID: '7',
    Country: 'Anguilla',
    Abbreviation: 'AI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '7': {
    CountryID: '8',
    Country: 'Antigua Barbuda',
    Abbreviation: 'AG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '8': {
    CountryID: '9',
    Country: 'Argentina',
    Abbreviation: 'AR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '9': {
    CountryID: '10',
    Country: 'Aruba',
    Abbreviation: 'AW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '10': {
    CountryID: '11',
    Country: 'Australia',
    Abbreviation: 'AU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '11': {
    CountryID: '12',
    Country: 'Austria',
    Abbreviation: 'AT',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '12': {
    CountryID: '13',
    Country: 'Azores',
    Abbreviation: 'AP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '13': {
    CountryID: '14',
    Country: 'Bahamas',
    Abbreviation: 'BS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '14': {
    CountryID: '15',
    Country: 'Bahrain',
    Abbreviation: 'BH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '15': {
    CountryID: '16',
    Country: 'Bangladesh',
    Abbreviation: 'BD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '16': {
    CountryID: '17',
    Country: 'Barbados',
    Abbreviation: 'BB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '17': {
    CountryID: '18',
    Country: 'Belgium',
    Abbreviation: 'BE',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '18': {
    CountryID: '19',
    Country: 'Belize',
    Abbreviation: 'BZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '19': {
    CountryID: '20',
    Country: 'Belarus',
    Abbreviation: 'BY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '20': {
    CountryID: '21',
    Country: 'Benin',
    Abbreviation: 'BJ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '21': {
    CountryID: '22',
    Country: 'Bermuda',
    Abbreviation: 'BM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '22': {
    CountryID: '23',
    Country: 'Bolivia',
    Abbreviation: 'BO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '23': {
    CountryID: '24',
    Country: 'Bonaire',
    Abbreviation: 'BL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '24': {
    CountryID: '25',
    Country: 'Bosnia',
    Abbreviation: 'BA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '25': {
    CountryID: '26',
    Country: 'Botswana',
    Abbreviation: 'BW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '26': {
    CountryID: '27',
    Country: 'Brazil',
    Abbreviation: 'BR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '27': {
    CountryID: '28',
    Country: 'British Virgin Islands',
    Abbreviation: 'VG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '28': {
    CountryID: '29',
    Country: 'Brunei',
    Abbreviation: 'BN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '29': {
    CountryID: '30',
    Country: 'Bulgaria',
    Abbreviation: 'BG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '30': {
    CountryID: '31',
    Country: 'Burkina Faso',
    Abbreviation: 'BF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '31': {
    CountryID: '32',
    Country: 'Burundi',
    Abbreviation: 'BI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '32': {
    CountryID: '33',
    Country: 'Cambodia',
    Abbreviation: 'KH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '33': {
    CountryID: '34',
    Country: 'Cameroon',
    Abbreviation: 'CM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '34': {
    CountryID: '36',
    Country: 'Canary Islands',
    Abbreviation: 'IC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '35': {
    CountryID: '37',
    Country: 'Cape Verde Islands',
    Abbreviation: 'CV',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '36': {
    CountryID: '38',
    Country: 'Cayman Islands',
    Abbreviation: 'KY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '37': {
    CountryID: '39',
    Country: 'Central African Republic',
    Abbreviation: 'CF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '38': {
    CountryID: '40',
    Country: 'Chad',
    Abbreviation: 'TD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '39': {
    CountryID: '41',
    Country: 'Channel Islands',
    Abbreviation: 'CD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '40': {
    CountryID: '42',
    Country: 'Chile',
    Abbreviation: 'CL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '41': {
    CountryID: '43',
    Country: 'China',
    Abbreviation: 'CN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'CNY',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '42': {
    CountryID: '44',
    Country: 'Colombia',
    Abbreviation: 'CO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '43': {
    CountryID: '45',
    Country: 'Congo',
    Abbreviation: 'CG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '44': {
    CountryID: '46',
    Country: 'Cook Islands',
    Abbreviation: 'CK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '45': {
    CountryID: '47',
    Country: 'Costa Rica',
    Abbreviation: 'CR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '46': {
    CountryID: '48',
    Country: 'Croatia',
    Abbreviation: 'HR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '47': {
    CountryID: '49',
    Country: 'Curacao',
    Abbreviation: 'CB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '48': {
    CountryID: '50',
    Country: 'Cyprus',
    Abbreviation: 'CY',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '49': {
    CountryID: '51',
    Country: 'Czech Republic',
    Abbreviation: 'CZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'CZK',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '50': {
    CountryID: '52',
    Country: 'Denmark',
    Abbreviation: 'DK',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'DKK',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '51': {
    CountryID: '53',
    Country: 'Djibouti',
    Abbreviation: 'DJ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '52': {
    CountryID: '54',
    Country: 'Dominica',
    Abbreviation: 'DM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '53': {
    CountryID: '55',
    Country: 'Dominican Republic',
    Abbreviation: 'DO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '54': {
    CountryID: '56',
    Country: 'Ecuador',
    Abbreviation: 'EC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '55': {
    CountryID: '57',
    Country: 'Egypt',
    Abbreviation: 'EG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '56': {
    CountryID: '58',
    Country: 'El Salvador',
    Abbreviation: 'SV',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '57': {
    CountryID: '59',
    Country: 'England',
    Abbreviation: 'EN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '58': {
    CountryID: '60',
    Country: 'Equitorial Guinea',
    Abbreviation: 'GQ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '59': {
    CountryID: '61',
    Country: 'Eritrea',
    Abbreviation: 'ER',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '60': {
    CountryID: '62',
    Country: 'Estonia',
    Abbreviation: 'EE',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '61': {
    CountryID: '63',
    Country: 'Ethiopia',
    Abbreviation: 'ET',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '62': {
    CountryID: '64',
    Country: 'Faeroe Islands',
    Abbreviation: 'FO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '63': {
    CountryID: '65',
    Country: 'Federated States of Micronesia',
    Abbreviation: 'FM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '64': {
    CountryID: '66',
    Country: 'Fiji',
    Abbreviation: 'FJ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '65': {
    CountryID: '67',
    Country: 'Finland',
    Abbreviation: 'FI',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '66': {
    CountryID: '68',
    Country: 'France',
    Abbreviation: 'FR',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '67': {
    CountryID: '69',
    Country: 'French Guiana',
    Abbreviation: 'GF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '68': {
    CountryID: '70',
    Country: 'French Polynesia',
    Abbreviation: 'PF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '69': {
    CountryID: '71',
    Country: 'Gabon',
    Abbreviation: 'GA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '70': {
    CountryID: '72',
    Country: 'Gambia',
    Abbreviation: 'GM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '71': {
    CountryID: '73',
    Country: 'Georgia',
    Abbreviation: 'GE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '72': {
    CountryID: '74',
    Country: 'Germany',
    Abbreviation: 'DE',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '73': {
    CountryID: '75',
    Country: 'Ghana',
    Abbreviation: 'GH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '74': {
    CountryID: '76',
    Country: 'Gibraltar',
    Abbreviation: 'GI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '75': {
    CountryID: '77',
    Country: 'Greece',
    Abbreviation: 'GR',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '76': {
    CountryID: '78',
    Country: 'Greenland',
    Abbreviation: 'GL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '77': {
    CountryID: '79',
    Country: 'Grenada',
    Abbreviation: 'GD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '78': {
    CountryID: '80',
    Country: 'Guadeloupe',
    Abbreviation: 'GP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '79': {
    CountryID: '81',
    Country: 'Guam',
    Abbreviation: 'GU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '80': {
    CountryID: '82',
    Country: 'Guatemala',
    Abbreviation: 'GT',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '81': {
    CountryID: '83',
    Country: 'Guinea',
    Abbreviation: 'GN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '82': {
    CountryID: '84',
    Country: 'Guinea-Bissau',
    Abbreviation: 'GW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '83': {
    CountryID: '85',
    Country: 'Guyana',
    Abbreviation: 'GY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '84': {
    CountryID: '86',
    Country: 'Haiti',
    Abbreviation: 'HT',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '85': {
    CountryID: '87',
    Country: 'Holland',
    Abbreviation: 'HO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '86': {
    CountryID: '88',
    Country: 'Honduras',
    Abbreviation: 'HN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '87': {
    CountryID: '89',
    Country: 'Hong Kong',
    Abbreviation: 'HK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '88': {
    CountryID: '90',
    Country: 'Hungary',
    Abbreviation: 'HU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'HUF',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '89': {
    CountryID: '91',
    Country: 'Iceland',
    Abbreviation: 'IS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '90': {
    CountryID: '92',
    Country: 'India',
    Abbreviation: 'IN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'INR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '91': {
    CountryID: '93',
    Country: 'Indonesia',
    Abbreviation: 'ID',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '92': {
    CountryID: '94',
    Country: 'Israel',
    Abbreviation: 'IL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '93': {
    CountryID: '95',
    Country: 'Italy',
    Abbreviation: 'IT',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '94': {
    CountryID: '96',
    Country: 'Ivory Coast',
    Abbreviation: 'CI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '95': {
    CountryID: '97',
    Country: 'Jamaica',
    Abbreviation: 'JM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '96': {
    CountryID: '98',
    Country: 'Japan',
    Abbreviation: 'JP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '97': {
    CountryID: '99',
    Country: 'Jordan',
    Abbreviation: 'JO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '98': {
    CountryID: '100',
    Country: 'Kazakhstan',
    Abbreviation: 'KZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '99': {
    CountryID: '101',
    Country: 'Kenya',
    Abbreviation: 'KE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '100': {
    CountryID: '102',
    Country: 'Kiribati',
    Abbreviation: 'KI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '101': {
    CountryID: '103',
    Country: 'Kosrae',
    Abbreviation: 'KO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '102': {
    CountryID: '104',
    Country: 'Kuwait',
    Abbreviation: 'KW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '103': {
    CountryID: '105',
    Country: 'Kyrgyzstan',
    Abbreviation: 'KG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '104': {
    CountryID: '106',
    Country: 'Laos',
    Abbreviation: 'LA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '105': {
    CountryID: '107',
    Country: 'Latvia',
    Abbreviation: 'LV',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '106': {
    CountryID: '108',
    Country: 'Lebanon',
    Abbreviation: 'LB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '107': {
    CountryID: '109',
    Country: 'Lesotho',
    Abbreviation: 'LS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '108': {
    CountryID: '110',
    Country: 'Liberia',
    Abbreviation: 'LR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '109': {
    CountryID: '111',
    Country: 'Liechtenstein',
    Abbreviation: 'LI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '110': {
    CountryID: '112',
    Country: 'Lithuania',
    Abbreviation: 'LT',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '111': {
    CountryID: '113',
    Country: 'Luxembourg',
    Abbreviation: 'LU',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '112': {
    CountryID: '114',
    Country: 'Macau',
    Abbreviation: 'MO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '113': {
    CountryID: '115',
    Country: 'Macedonia',
    Abbreviation: 'MK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '114': {
    CountryID: '116',
    Country: 'Madagascar',
    Abbreviation: 'MG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '115': {
    CountryID: '117',
    Country: 'Madeira',
    Abbreviation: 'ME',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '116': {
    CountryID: '118',
    Country: 'Malawi',
    Abbreviation: 'MW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '117': {
    CountryID: '119',
    Country: 'Malaysia',
    Abbreviation: 'MY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '118': {
    CountryID: '120',
    Country: 'Maldives',
    Abbreviation: 'MV',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '119': {
    CountryID: '121',
    Country: 'Mali',
    Abbreviation: 'ML',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '120': {
    CountryID: '122',
    Country: 'Malta',
    Abbreviation: 'MT',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '121': {
    CountryID: '123',
    Country: 'Marshall Islands',
    Abbreviation: 'MH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '122': {
    CountryID: '124',
    Country: 'Martinique',
    Abbreviation: 'MQ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '123': {
    CountryID: '125',
    Country: 'Mauritania',
    Abbreviation: 'MR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '124': {
    CountryID: '126',
    Country: 'Mauritius',
    Abbreviation: 'MU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '125': {
    CountryID: '127',
    Country: 'Mexico',
    Abbreviation: 'MX',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '126': {
    CountryID: '128',
    Country: 'Moldova',
    Abbreviation: 'MD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '127': {
    CountryID: '129',
    Country: 'Monaco',
    Abbreviation: 'MC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '128': {
    CountryID: '130',
    Country: 'Montserrat',
    Abbreviation: 'MS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '129': {
    CountryID: '131',
    Country: 'Morocco',
    Abbreviation: 'MA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '130': {
    CountryID: '132',
    Country: 'Mozambique',
    Abbreviation: 'MZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '131': {
    CountryID: '133',
    Country: 'Myanmar',
    Abbreviation: 'MM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '132': {
    CountryID: '134',
    Country: 'Namibia',
    Abbreviation: 'NA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '133': {
    CountryID: '135',
    Country: 'Nepal',
    Abbreviation: 'NP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '134': {
    CountryID: '136',
    Country: 'Netherlands',
    Abbreviation: 'NL',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '135': {
    CountryID: '137',
    Country: 'Netherlands Antilles',
    Abbreviation: 'AN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '136': {
    CountryID: '138',
    Country: 'New Caledonia',
    Abbreviation: 'NC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '137': {
    CountryID: '139',
    Country: 'New Zealand',
    Abbreviation: 'NZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '138': {
    CountryID: '140',
    Country: 'Nicaragua',
    Abbreviation: 'NI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '139': {
    CountryID: '141',
    Country: 'Niger',
    Abbreviation: 'NE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '140': {
    CountryID: '142',
    Country: 'Nigeria',
    Abbreviation: 'NG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '141': {
    CountryID: '143',
    Country: 'Norfolk Island',
    Abbreviation: 'NF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '142': {
    CountryID: '144',
    Country: 'Northern Ireland',
    Abbreviation: 'NB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '143': {
    CountryID: '145',
    Country: 'Northern Mariana Islands',
    Abbreviation: 'MP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '144': {
    CountryID: '146',
    Country: 'Norway',
    Abbreviation: 'NO',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'NOK',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '145': {
    CountryID: '147',
    Country: 'Oman',
    Abbreviation: 'OM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '146': {
    CountryID: '148',
    Country: 'Pakistan',
    Abbreviation: 'PK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '147': {
    CountryID: '149',
    Country: 'Palau',
    Abbreviation: 'PW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '148': {
    CountryID: '150',
    Country: 'Panama',
    Abbreviation: 'PA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '149': {
    CountryID: '151',
    Country: 'Papua New Guinea',
    Abbreviation: 'PG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '150': {
    CountryID: '152',
    Country: 'Paraguay',
    Abbreviation: 'PY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '151': {
    CountryID: '153',
    Country: 'Peru',
    Abbreviation: 'PE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '152': {
    CountryID: '154',
    Country: 'Philippines',
    Abbreviation: 'PH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'PHP',
    DeliveryMethods: {
      '0': 'bank',
      '1': 'cash',
    },
  },
  '153': {
    CountryID: '155',
    Country: 'Poland',
    Abbreviation: 'PL',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'PLN',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '154': {
    CountryID: '156',
    Country: 'Ponape',
    Abbreviation: 'PO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '155': {
    CountryID: '157',
    Country: 'Portugal',
    Abbreviation: 'PT',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '156': {
    CountryID: '158',
    Country: 'Puerto Rico',
    Abbreviation: 'PR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '157': {
    CountryID: '159',
    Country: 'Qatar',
    Abbreviation: 'QA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '158': {
    CountryID: '160',
    Country: 'Republic of Ireland',
    Abbreviation: 'IE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '159': {
    CountryID: '161',
    Country: 'Republic of Yemen',
    Abbreviation: 'YE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '160': {
    CountryID: '162',
    Country: 'Reunion',
    Abbreviation: 'RE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '161': {
    CountryID: '163',
    Country: 'Romania',
    Abbreviation: 'RO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '162': {
    CountryID: '164',
    Country: 'Rota',
    Abbreviation: 'RT',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '163': {
    CountryID: '165',
    Country: 'Russia',
    Abbreviation: 'RU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '164': {
    CountryID: '166',
    Country: 'Rwanda',
    Abbreviation: 'RW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '165': {
    CountryID: '167',
    Country: 'Saba',
    Abbreviation: 'SS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '166': {
    CountryID: '168',
    Country: 'Saipan',
    Abbreviation: 'SP',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '167': {
    CountryID: '169',
    Country: 'Saudi Arabia',
    Abbreviation: 'SA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '168': {
    CountryID: '170',
    Country: 'Scotland',
    Abbreviation: 'SF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '169': {
    CountryID: '171',
    Country: 'Senegal',
    Abbreviation: 'SN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '170': {
    CountryID: '172',
    Country: 'Seychelles',
    Abbreviation: 'SC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '171': {
    CountryID: '173',
    Country: 'Sierra Leone',
    Abbreviation: 'SL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '172': {
    CountryID: '174',
    Country: 'Singapore',
    Abbreviation: 'SG',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'SGD',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '173': {
    CountryID: '175',
    Country: 'Slovakia',
    Abbreviation: 'SK',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '174': {
    CountryID: '176',
    Country: 'Slovenia',
    Abbreviation: 'SI',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '175': {
    CountryID: '177',
    Country: 'Solomon Islands',
    Abbreviation: 'SB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '176': {
    CountryID: '178',
    Country: 'South Africa',
    Abbreviation: 'ZA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '177': {
    CountryID: '179',
    Country: 'South Korea',
    Abbreviation: 'KR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '178': {
    CountryID: '180',
    Country: 'Spain',
    Abbreviation: 'ES',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '179': {
    CountryID: '181',
    Country: 'Sri Lanka',
    Abbreviation: 'LK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '180': {
    CountryID: '182',
    Country: 'St. Barthelemy',
    Abbreviation: 'NT',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '181': {
    CountryID: '183',
    Country: 'St. Christopher',
    Abbreviation: 'SW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '182': {
    CountryID: '184',
    Country: 'St. Croix',
    Abbreviation: 'SX',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '183': {
    CountryID: '185',
    Country: 'St. Eustatius',
    Abbreviation: 'EU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '184': {
    CountryID: '186',
    Country: 'St. John',
    Abbreviation: 'UV',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '185': {
    CountryID: '187',
    Country: 'St. Kitts Nevis',
    Abbreviation: 'KN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '186': {
    CountryID: '188',
    Country: 'St. Lucia',
    Abbreviation: 'LC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '187': {
    CountryID: '189',
    Country: 'St. Maarten',
    Abbreviation: 'MB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '188': {
    CountryID: '190',
    Country: 'St. Martin',
    Abbreviation: 'TB',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '189': {
    CountryID: '191',
    Country: 'St. Thomas',
    Abbreviation: 'VL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '190': {
    CountryID: '192',
    Country: 'St. Vincent the Grenadines',
    Abbreviation: 'VC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '191': {
    CountryID: '193',
    Country: 'Sudan',
    Abbreviation: 'SD',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '192': {
    CountryID: '194',
    Country: 'Suriname',
    Abbreviation: 'SR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '193': {
    CountryID: '195',
    Country: 'Swaziland',
    Abbreviation: 'SZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '194': {
    CountryID: '196',
    Country: 'Sweden',
    Abbreviation: 'SE',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'SEK',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '195': {
    CountryID: '197',
    Country: 'Switzerland',
    Abbreviation: 'CH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '196': {
    CountryID: '198',
    Country: 'Syria',
    Abbreviation: 'SY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '197': {
    CountryID: '199',
    Country: 'Tahiti',
    Abbreviation: 'TA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '198': {
    CountryID: '200',
    Country: 'Taiwan',
    Abbreviation: 'TW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '199': {
    CountryID: '201',
    Country: 'Tajikistan',
    Abbreviation: 'TJ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '200': {
    CountryID: '202',
    Country: 'Tanzania',
    Abbreviation: 'TZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '201': {
    CountryID: '203',
    Country: 'Thailand',
    Abbreviation: 'TH',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '202': {
    CountryID: '204',
    Country: 'Tinian',
    Abbreviation: 'TI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '203': {
    CountryID: '205',
    Country: 'Togo',
    Abbreviation: 'TG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '204': {
    CountryID: '206',
    Country: 'Tonga',
    Abbreviation: 'TO',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '205': {
    CountryID: '207',
    Country: 'Tortola',
    Abbreviation: 'TL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '206': {
    CountryID: '208',
    Country: 'Trinidad Tobago',
    Abbreviation: 'TT',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '207': {
    CountryID: '209',
    Country: 'Truk',
    Abbreviation: 'TU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '208': {
    CountryID: '210',
    Country: 'Tunisia',
    Abbreviation: 'TN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '209': {
    CountryID: '211',
    Country: 'Turkey',
    Abbreviation: 'TR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '210': {
    CountryID: '212',
    Country: 'Turks Caicos Islands',
    Abbreviation: 'TC',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '211': {
    CountryID: '213',
    Country: 'Tuvalu',
    Abbreviation: 'TV',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '212': {
    CountryID: '214',
    Country: 'Uganda',
    Abbreviation: 'UG',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '213': {
    CountryID: '215',
    Country: 'Ukraine',
    Abbreviation: 'UA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '214': {
    CountryID: '216',
    Country: 'Union Island',
    Abbreviation: 'UI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '215': {
    CountryID: '217',
    Country: 'United Arab Emirates',
    Abbreviation: 'AE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '216': {
    CountryID: '218',
    Country: 'United Kingdom',
    Abbreviation: 'GB',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'GBP',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '217': {
    CountryID: '220',
    Country: 'Uruguay',
    Abbreviation: 'UY',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '218': {
    CountryID: '221',
    Country: 'US Virgin Islands',
    Abbreviation: 'VI',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '219': {
    CountryID: '222',
    Country: 'Uzbekistan',
    Abbreviation: 'UZ',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '220': {
    CountryID: '223',
    Country: 'Vanuatu',
    Abbreviation: 'VU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '221': {
    CountryID: '224',
    Country: 'Venezuela',
    Abbreviation: 'VE',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '222': {
    CountryID: '225',
    Country: 'Vietnam',
    Abbreviation: 'VN',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '223': {
    CountryID: '226',
    Country: 'Virgin Gorda',
    Abbreviation: 'VR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '224': {
    CountryID: '227',
    Country: 'Wake Island',
    Abbreviation: 'WK',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '225': {
    CountryID: '228',
    Country: 'Wales',
    Abbreviation: 'WL',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '226': {
    CountryID: '229',
    Country: 'Wallis Futuna Islands',
    Abbreviation: 'WF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '227': {
    CountryID: '230',
    Country: 'Western Samoa',
    Abbreviation: 'WS',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '228': {
    CountryID: '231',
    Country: 'Yap',
    Abbreviation: 'YA',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '229': {
    CountryID: '232',
    Country: 'Yugoslavia',
    Abbreviation: 'YU',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '230': {
    CountryID: '233',
    Country: 'Zaire',
    Abbreviation: 'ZR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '231': {
    CountryID: '234',
    Country: 'Zambia',
    Abbreviation: 'ZM',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '232': {
    CountryID: '235',
    Country: 'Zimbabwe',
    Abbreviation: 'ZW',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '233': {
    CountryID: '236',
    Country: 'Ireland',
    Abbreviation: 'IE',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'EUR',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '234': {
    CountryID: '237',
    Country: 'Iran',
    Abbreviation: 'IR',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '235': {
    CountryID: '238',
    Country: 'Afghanistan',
    Abbreviation: 'AF',
    Airtime: '0',
    MoneyTransfer: '0',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: null,
    DeliveryMethods: {
      '0': 'bank',
    },
  },
  '236': {
    CountryID: '239',
    Country: 'Australia',
    Abbreviation: 'AU',
    Airtime: '0',
    MoneyTransfer: '1',
    BillPayment: '0',
    Voucher: '0',
    DefaultCurrency: 'AUD',
    DeliveryMethods: {
      '0': 'bank',
    },
  },
};

export default countries;
